import { render } from "./SupplierCurrenciesRates.vue?vue&type=template&id=0bc42626"
import script from "./SupplierCurrenciesRates.vue?vue&type=script&lang=js"
export * from "./SupplierCurrenciesRates.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__